import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getLineChartLegendStyles = props => {
  var _a, _b;
  return StyleSheet.create({
    container: {
      display: 'flex',
      flexDirection: 'row',
      width: "100%/" + ((_b = (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.datasets) === null || _b === void 0 ? void 0 : _b.length),
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: tokens.spacing.SPACING_4
    },
    checkbox: {
      marginRight: tokens.spacing.SPACING_4,
      minWidth: 114,
      alignSelf: 'center'
    },
    legendContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: tokens.spacing.SPACING_8
    }
  });
};